import { useCallback } from 'react';
import { HUBSPOT_APP_LINK_TYPES, useHubSpotAppLinkHandler } from '../common/context/HubSpotAppLinkHandlerContext';
import { fetchAssociatedObjectsRecord, shouldLinkToAssociation } from './internal/useAssociatedObjectsRecord';
import { fetchObjectTypeSupportsRecord } from './internal/useObjectTypeSupportsRecord';
import { getNonRecordPageHref, getRecordHref, getRecordPageHref, isSupportedNonRecordPageObjectType } from './internal/getRecordHref';
/**
 * @deprecated
 * DO NOT USE!!!
 * This hook is not ready for public consumption yet. We would like to have the RecordLink component be based upon this before we expose it publicly.
 */
export const useGetRecordLink = () => {
  const linkHandler = useHubSpotAppLinkHandler(HUBSPOT_APP_LINK_TYPES.CRM_OBJECT_RECORD);
  return useCallback(async ({
    objectTypeId,
    objectId,
    includeEschref = false,
    external
  }) => {
    if (shouldLinkToAssociation(objectTypeId)) {
      const maybeAssociatedResult = await fetchAssociatedObjectsRecord({
        objectTypeId,
        objectId
      });
      const href = getRecordHref(maybeAssociatedResult.objectTypeId, maybeAssociatedResult.objectId, includeEschref);
      return {
        onClick: linkHandler.onClick,
        href,
        external
      };
    }
    if (isSupportedNonRecordPageObjectType(objectTypeId)) {
      const href = getNonRecordPageHref(objectTypeId, objectId, includeEschref);
      if (!href) {
        return null;
      }
      return {
        onClick: linkHandler.onClick,
        href,
        external
      };
    }
    const objectTypeSupportsRecord = await fetchObjectTypeSupportsRecord(objectTypeId);
    if (!objectTypeSupportsRecord) {
      return null;
    }
    if (external) {
      const href = getRecordPageHref(objectTypeId, objectId, includeEschref) || null;
      if (!href) {
        return null;
      }
      return {
        onClick: linkHandler.onClick,
        href,
        external
      };
    }
    return {
      href: linkHandler.getHref({
        objectTypeId,
        objectId,
        includeEschref
      }),
      onClick: linkHandler.onClick,
      external
    };
  }, [linkHandler]);
};